import { useAnalytics } from '@app/features/analytics/hooks/use-analytics';
import { ClearIcon } from '@app/features/analytics/icons/clear';
import { SearchIcon } from '@app/features/analytics/icons/search';
import { getTitleCase } from '@app/features/analytics/utils';
import { useAppDispatch } from '@app/store/store';
import { useTranslation } from '@hopin-team/provider-translation';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useDebounce } from 'use-debounce';

import { selectAnalyticsSeriesInfo } from '../../selectors';
import { OutlineOnFocus } from '../../styles';

const SEARCH_DEBOUNCE_MS = 500;

export const SearchSeries = () => {
  const { t } = useTranslation();
  const { filters } = useSelector(selectAnalyticsSeriesInfo);
  const dispatch = useAppDispatch();
  const [searchString, setSearchString] = useState(filters.searchText);
  const [debouncedSearchString] = useDebounce(searchString, SEARCH_DEBOUNCE_MS);

  useEffect(() => {
    setSearchString(filters.searchText || '');
  }, [filters.searchText]);
  const { track } = useAnalytics();
  useEffect(() => {
    const searchText = debouncedSearchString?.trim();
    dispatch({
      type: '[analytics] update series search text',
      payload: {
        searchText: searchText,
      },
    });

    if (searchText) {
      track('ola_search_text', {
        searchText: searchText,
        tab: getTitleCase('series'),
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedSearchString]);

  const handleChange = (event: { target: { value: string } }) => {
    setSearchString(event.target.value);
  };

  const handleClear = () => {
    setSearchString('');
  };

  return (
    <div className="relative w-full">
      <span className="absolute left-2 top-[9px]">
        <SearchIcon />
      </span>

      <input
        type="text"
        value={searchString}
        onChange={handleChange}
        name={'search'}
        placeholder={t('analytics.search-series')}
        className={
          'px-9 py-1 h-10 w-56 border-neutral-b4 rounded-lg focus:border-blue-500' +
          OutlineOnFocus
        }
      />

      {searchString && (
        <button
          className="absolute right-2 top-[9px] hover:text-gray-600"
          onClick={handleClear}
          title="Clear"
          data-testid="clear-search"
        >
          <ClearIcon />
        </button>
      )}
    </div>
  );
};
